import script from "./GuideStep1.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideStep1.vue?vue&type=script&setup=true&lang=js"

import "./GuideStep1.vue?vue&type=style&index=0&id=239974a9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239974a9"]])

export default __exports__